/* ══════════════════════════════════════════════════════════════════════════
   TRADE TERVEZŐ: a terv számai (Terminál-javítások 1. kör, A.1) — tiszta függvény
   ─────────────────────────────────────────────────────────────────────────
   Kockázat-mód: a Pozíció Méret = (tőke × kockázat%) / stoptávolság, a Max Veszteség
   = tőke × kockázat% (változatlan).
   Tőkeáttétel-mód: a Pozíció Méret = tőke × tőkeáttétel, a Max Veszteség = pozícióméret ×
   stoptávolság (korábban hibásan a tőke × kockázat% maradt), mellette a tőke hány %-a.
   A stoptávolság irányfüggetlen (|belépő − stop| / belépő), long és short ugyanúgy.
   ══════════════════════════════════════════════════════════════════════════ */

export function tervSzamitas({ capital, riskPct, entry, sl, leverageMode, manualLev }) {
  const cap = Number(capital) || 0;
  const maxRisk = cap * (Number(riskPct) || 0) / 100;
  const e = Number(entry) || 0, s = Number(sl) || 0;
  const slDist = e > 0 && s > 0 ? Math.abs(e - s) / e : 0;
  const lev = Number(manualLev) || 1;
  const levMode = leverageMode === 'leverage';
  const posSizeUSD = levMode ? cap * lev : (slDist > 0 ? maxRisk / slDist : 0);
  const leverage = levMode ? lev : (cap > 0 && posSizeUSD > 0 ? posSizeUSD / cap : 0);
  const maxLoss = slDist > 0 ? (levMode ? posSizeUSD * slDist : maxRisk) : 0;
  const maxLossPctOfCapital = cap > 0 && slDist > 0 ? (maxLoss / cap) * 100 : null;
  return { maxRisk, slDist, posSizeUSD, leverage, maxLoss, maxLossPctOfCapital };
}
